import {Types} from "@Common/types";

import {addMap} from "./math-util";
import {parseNodes} from "./path-pattern";
import {cascadeNodesChange, cascadeNodes, cascadeNodesFind} from "./cascade-nodes";

export const cascade = (obj, pathStr, map=undefined) => cascadeNodes(obj, parseNodes(pathStr), map);

export const cascadeFind = (obj, pathStr, check=undefined) => cascadeNodesFind(obj, parseNodes(pathStr), check);
export const cascadeMap:Types.Common.Utils.Cascade.CascadeMap = (obj, path, fn:any = (...args:any[])=>args[0]||0 ) => {
    let ret = [];
    cascadeNodesFind(obj, parseNodes(Array.isArray(path) ? pathArrayAsStr(path) : path), (...args) => {
        const found = fn(...args);
        if (found) {
            ret.push(found);
        }
    });
    return ret;
};
export const cascadeCollect = cascadeMap;

export const cascadeEach = (obj, pathStr, fn) => cascadeNodesFind(obj, parseNodes(pathStr), (...args) => { fn(...args) });

export const cascadeChange = (obj, pathStr, fn) => {
    return cascadeNodesChange(obj, parseNodes(pathStr), fn);
};
export const cascadeSum:Types.Common.Utils.Cascade.CascadeSum = (obj, pathStr, fn = (...args)=>args[0]||0 ) => {
    let total = null;
    cascadeNodesFind(obj, parseNodes(pathStr), (...args) => {
        const value = fn(...args);
        if (!isNaN(value)) {
            total = total == null ? value : (
                total + value
            );
        }
    });
    return total;
};

export const cascadeSumMap = (obj, pathStr, fn = (...args)=>args[0]||0 ) => {
    let total = {};
    cascadeNodesFind(obj, parseNodes(pathStr), (...args) => {
        total = addMap(total, fn(...args));
    });
    return total;
};

export const cascadeCount = (obj, pathStr, fn = (...args)=>args[0]||0 ) => {
    let total = 0;
    cascadeNodesFind(obj, parseNodes(pathStr), (...args) => {
        if (fn(...args)) {
            total ++;
        }
    });
    return total;
};

export const pathArrayAsStr = (path:(string | number)[]): string => (
    path.map((part, index) => part === "*" ? "[*]" : index > 0 ? `.${part}` : part).join("")
);

